import { PaginationParams } from '../general-store/general.model';
import {
  CreateReportPayload,
  CreateVisualizationPayload,
  ScheduleReportPayload,
} from './report.model';

const CONTEXT = '[ReportStore]';

export class GetReportList {
  static readonly type = `${CONTEXT} Get Report List`;
  constructor(public payload: PaginationParams) {}
}

export class GetReport {
  static readonly type = `${CONTEXT} Get Report`;
  constructor(public id: number) {}
}

export class GetViewReportData {
  static readonly type = `${CONTEXT} Get View Report Data`;
  constructor(
    public id: number,
    public payload: PaginationParams,
  ) {}
}

export class CreateReport {
  static readonly type = `${CONTEXT} Create Report`;
  constructor(public payload: CreateReportPayload) {}
}

export class CreateVisualization {
  static readonly type = `${CONTEXT} Create Visualization`;
  constructor(
    public id: number,
    public payload: CreateVisualizationPayload,
  ) {}
}

export class UpdateReport {
  static readonly type = `${CONTEXT} Update Report`;
  constructor(
    public id: number,
    public payload: CreateReportPayload,
  ) {}
}

export class UpdateVisualization {
  static readonly type = `${CONTEXT} Update Visualization`;
  constructor(
    public reportId: number,
    public visualizationId: number,
    public payload: CreateVisualizationPayload,
  ) {}
}

export class DeleteReport {
  static readonly type = `${CONTEXT} Delete Report`;
  constructor(public id: number) {}
}

export class DeleteVisualization {
  static readonly type = `${CONTEXT} Delete Visualization`;
  constructor(
    public reportId: number,
    public visualizationId: number,
  ) {}
}

export class ClearReport {
  static readonly type = `${CONTEXT} Clear Report`;
}

export class GetVisualizationData {
  static readonly type = `${CONTEXT} Get Visualization Data`;
  constructor(
    public reportId: number,
    public visualizationId: number,
  ) {}
}

export class ScheduleReport {
  static readonly type = `${CONTEXT} Schedule Report`;
  constructor(public payload: ScheduleReportPayload) {}
}

export class GetFarmerReceipt {
  static readonly type = `${CONTEXT} Get Farmer Receipt`;
  constructor(public payload: PaginationParams) {}
}

export class GetTransferVoucher {
  static readonly type = `${CONTEXT} Get Transfer Voucher`;
  constructor(public payload: PaginationParams) {}
}

export class GetReceiving {
  static readonly type = `${CONTEXT} Get Receiving`;
  constructor(public payload: PaginationParams) {}
}

export class GetReconciliation {
  static readonly type = `${CONTEXT} Get Reconciliation`;
  constructor(public payload: PaginationParams) {}
}

export class GetBagTraceability {
  static readonly type = `${CONTEXT} Get Bag Traceability`;
  constructor(public payload: PaginationParams) {}
}

export class GetTransactionsSummary {
  static readonly type = `${CONTEXT} Get Transactions Summary`;
  constructor(public payload: PaginationParams) {}
}

export class ExportStaticReport {
  static readonly type = `${CONTEXT} Export Static Report`;
  constructor(
    public reportType: string,
    public filters: string,
  ) {}
}

export class ExportProductReportCsv {
  static readonly type = `${CONTEXT} Export Product Report CSV`;
  constructor(
    public reportId: number,
    public recordIds?: number[],
  ) {}
}
